import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import _ from "lodash";
import IntroductionData from "./IntroductionData";

const PendingSendIntroductionList = (props) => {
  const {
    list,
    count,
    updateIntroPageOnScroll,
    CancelIntroduction,
    ViewIntroductionModalShow,
    acceptedCount
  } = props;
  const scrollRef = useRef(null);

  const handleScroll = () => {
    const el = scrollRef.current;
    const scrollHeight = el.scrollHeight;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    if (
      scrollHeight !== clientHeight &&
      scrollTop !== 0 &&
      Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
    ) {
      const section = "pending";
      updateIntroPageOnScroll(section);
    } else if (scrollTop === 0 && scrollHeight !== clientHeight) {
      //setCurrPage(prevState => prevState -1);
    }
  };

  return (
    <>
      {count > 0 ? (
        <div className="intro-list-sec">
          <div className="title-sec">
            <h5>
              Pending <span>({count})</span>
            </h5>
          </div>
          <div
            className="property-block-scroll"
            onScroll={handleScroll}
            ref={scrollRef}
          >
            {list.map((intro) => {
             const introId =  _.get(intro, "IntroductionId", "")
              return (
                <div className="property-block" key={introId}>
                  <div
                    className="property-info property-info-hoverstyling"
                    onClick={()=>{props.ViewWantAd(introId)}}
                  >
                    <IntroductionData introList={intro} />
                  </div>
                  <div className="property-action flex-shrink-0">
                    <Button
                      variant="light"
                      className="btn-cancel"
                      onClick={()=>{CancelIntroduction(introId)}}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant=""
                      className="btn-tertiary"
                      onClick={()=>{props.ViewWantAd(introId)}}
                    >
                      View Introduction
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )
    :
    (
      acceptedCount == 0 &&
      <p>No Introductions.</p>
    )
    // <p>No Pending Introductions.</p>
    }
    </>
  );
};
export default PendingSendIntroductionList;
